export const PUBLIC_MEDIA_CONTRACT_VERSION = "public-media-v1";
export const PUBLIC_MEDIA_SOURCE = "public-media";

const isObject = (value) => Boolean(value && typeof value === "object" && !Array.isArray(value));

export const resolvePublicMediaContract = (entity) => {
  const contract = entity?.publicMedia;
  if (
    contract?.contractVersion === PUBLIC_MEDIA_CONTRACT_VERSION
    && contract?.sourceOfTruth === PUBLIC_MEDIA_SOURCE
    && Array.isArray(contract.items)
  ) {
    return contract;
  }
  return null;
};

export const resolvePublicMediaItems = (entity) => {
  const contract = resolvePublicMediaContract(entity);
  return contract ? contract.items : null;
};

export const resolvePublicMediaPrimary = (entity) => {
  const contract = resolvePublicMediaContract(entity);
  return contract ? contract.primary || null : null;
};

export const resolvePublicMediaCover = (entity) => {
  const contract = resolvePublicMediaContract(entity);
  return contract ? contract.cover || contract.items[0] || contract.primary || null : null;
};

export const isPublicMediaCanonical = (entity) => {
  const contract = resolvePublicMediaContract(entity);
  return Boolean(contract && ["canonical", "published"].includes(contract.state));
};

export const isPublicMediaLegacyFallback = (entity) => {
  const contract = resolvePublicMediaContract(entity);
  return Boolean(contract && (contract.state === "legacy-fallback" || contract.legacyFallback));
};

export const validatePublicMediaContract = (entity) => {
  const contract = resolvePublicMediaContract(entity);
  if (!contract) return ["publicMedia must use the public-media-v1 contract."];
  const errors = [];
  if (!isObject(contract.counts)) errors.push("publicMedia.counts is required.");
  if (!isObject(contract.order)) errors.push("publicMedia.order is required.");
  if (!["canonical", "published", "legacy-fallback", "empty"].includes(contract.state)) {
    errors.push("publicMedia.state is invalid.");
  }
  if (contract.state === "empty" && contract.items.length) {
    errors.push("An empty publicMedia contract cannot contain items.");
  }
  if (contract.state === "legacy-fallback" && contract.legacyFallback !== true) {
    errors.push("A legacy-fallback publicMedia contract must declare legacyFallback=true.");
  }
  return errors;
};

export default resolvePublicMediaContract;
